import styled from "styled-components";

import { useContext, useEffect, useRef, useState } from "react";
import Context from "../../../../Context.js";
import { useTranslation } from "react-i18next";
import LoginPage from "../auth/LoginPage.js";

const ParentContainer = styled.div`
  display: flex;
  width: 100vw;

  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Tagline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  /* align-items: center; */

  animation: centerScaleReveal 0.4s ease-in;

  @media (max-width: 900px) {
    justify-content: center;
    align-items: center;
    /* flex-direction: row; */
    width: 100%;
  }
`;

const Taglines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  /* align-items: center; */

  @media (max-width: 900px) {
    justify-content: center;
    align-items: center;
    gap: 0;
    flex-direction: column;
    gap: 20px;
    /* flex-direction: row; */
    width: 100%;
  }
`;

const TaglineLine = styled.div`
  color: var(--accent);
  font-size: 65px;
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  font-style: italic;

  @media (max-width: 900px) {
    font-size: 30px;
    text-align: center;
    width: auto;
  }
`;

const TaglineLine2 = styled(TaglineLine)`
  font-size: 65px;

  @media (max-width: 900px) {
    font-size: 30px;
  }
`;

const MainButtons = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 900px) {
    justify-content: center;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const Medium = styled.div`
  font-size: 18px;
  font-weight: 600;

  line-height: 30px;
  font-family: "Questrial", serif;
  width: 400px;

  animation: centerScaleReveal 0.4s ease-in;
  opacity: 0.5 !important;

  @media (max-width: 900px) {
    width: 100%;
    padding: 0 30px;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 19px;
  align-items: flex-start;
  margin-top: 10px;
`;

const HeroSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 85vw;
  height: 60vh;
  gap: 100px;

  @media (max-width: 900px) {
    height: auto;
    gap: 20px;
    width: 95vw;
    flex-direction: column-reverse;
  }
`;

export default function LoggedOutHomePage() {
  const { isMobile } = useContext(Context);

  const [refreshRef, setRefreshRef] = useState(null);

  const { t } = useTranslation();

  //without this line we will not be able to refresh once the page is changed
  //the above line prevents a buh in which when we go to the login page and backend to the homepage
  //the ref disappears

  useEffect(() => {
    setRefreshRef(true);
  }, []);

  console.log(refreshRef);

  const containerRef = useRef();

  console.log("containerRef.current", containerRef.current);

  return <LoginPage />;
}
